import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import styles from "../../Dashboard.module.css";
import GenericDatePicker from '../../../../../components/GenericDatePicker';
import Select from '../../../../../components/Select';

const FullChartsFilterRow = forwardRef((props, ref) => {
    const {
        isExporting,
        period,
        handleSelectDate,
        groupBy,
        setGroupBy,
        tipoVisualizacao,
        setTipoVisualizacao,
        mostrarExcedidos,
        setMostrarExcedidos,
        mostrarInicioDia,
        setMostrarInicioDia,
        data,
        getChartsData,
        handleExportPDF,
        isLoadingFullCharts,
        groupByOptions,
        currentFilterLabel
    } = props;
    const exportButtonRef = useRef();

    useImperativeHandle(ref, () => ({
        exportButton: exportButtonRef.current
    }));
    return (
        <>
            <GenericDatePicker
                key={`date-picker-${isExporting}`}
                value={period}
                onChange={handleSelectDate}
                onApply={() => getChartsData()}
                showLabel
                maxDate={new Date()}
                emitOnMount
                datepickerStyle={{ padding: "0" }}
                toggleStyle={{
                    backgroundColor: "#fff",
                    border: "1.5px solid #D9D9D9",
                    borderRadius: "8px",
                    position: "relative"
                }}
                panelStyle={{ top: "120px" }}
                disable={isLoadingFullCharts}
            />

            <div style={{ width: "5rem" }}>
                <Select
                    value={groupBy}
                    options={groupByOptions}
                    onChange={setGroupBy}
                    disabled={isLoadingFullCharts}
                />
            </div>

            <div className={styles.fullChartsTypeGroup}>
                {isExporting ? (
                    <div className={`${styles.fullChartsFilterBtn} ${styles.active}`}>
                        <strong>Visualização:</strong> {currentFilterLabel}
                    </div>
                ) : (
                    [
                        { id: "todos", label: "Todos" },
                        ...(data?.charts || []).map(chart => ({
                            id: chart.id,
                            label: chart.descricao
                        }))
                    ].map(type => (
                        <button
                            key={type.id}
                            className={`${styles.fullChartsFilterBtn} ${tipoVisualizacao === type.id ? styles.active : ""}`}
                            onClick={() => setTipoVisualizacao(type.id)}
                        >
                            {type.label}
                        </button>
                    ))
                )}
            </div>

            <button
                className={`${styles.fullChartsFilterBtn} ${mostrarExcedidos ? styles.active : ""}`}
                onClick={() => setMostrarExcedidos(prev => !prev)}
            >
                Excedidos
            </button>

            <button
                className={`${styles.fullChartsFilterBtn} ${mostrarInicioDia ? styles.active : ""}`}
                onClick={() => setMostrarInicioDia(prev => !prev)}
            >
                Inicio do Dia
            </button>

            {(data?.charts?.length && !isLoadingFullCharts) && (
                <button
                    ref={exportButtonRef}
                    className={styles.fullChartsExportBtn}
                    onClick={handleExportPDF}
                >
                    Exportar PDF
                </button>
            )}
        </>
    )
})

export default FullChartsFilterRow;